export default {"src":"/_next/static/media/uk-flag.fc7e250d.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};